const s = {
  lg: 34,
  md: 30,
  sm: 24,
  xs: 16
};
export {
  s as LOADER_SIZES_MAP
};
//# sourceMappingURL=constants21.mjs.map
